import {Migration} from "@app/core/shared/infrastructure/migration/interfaces/migration";
import {EnvironmentPlatform} from "src/environments/environment-template";

const CREDENTIALS_STORAGE_KEY = "credentials";

export const credentialsMigration: Migration = {
  version: 2,
  updateFn: async (context) => {
    const isMobile =
      context.platform === EnvironmentPlatform.IOS ||
      context.platform === EnvironmentPlatform.AND;

    if (!isMobile) return;

    const credentials = context.storage.getItem(CREDENTIALS_STORAGE_KEY);

    if (!credentials) return;

    // add object to new db
    await context.secureStorage.setItem(CREDENTIALS_STORAGE_KEY, credentials);

    // Delete old data
    context.storage.removeItem(CREDENTIALS_STORAGE_KEY);
  },
};
